module.exports = __webpack_public_path__ + "static/media/vencimiento_amarillo.67778bd4.svg";